var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "activity-goods-form" },
    [
      _c(
        "el-radio-group",
        {
          staticStyle: { "margin-bottom": "20px" },
          attrs: { size: "small" },
          model: {
            value: _vm.activeSetting,
            callback: function ($$v) {
              _vm.activeSetting = $$v
            },
            expression: "activeSetting",
          },
        },
        [
          _c("el-radio-button", { attrs: { label: 1 } }, [_vm._v("内容")]),
          _vm._v(" "),
          _c("el-radio-button", { attrs: { label: 2 } }, [_vm._v("样式")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeSetting === 1,
              expression: "activeSetting === 1",
            },
          ],
          attrs: { model: _vm.itemInfo, "label-width": "130px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "活动类型：" } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: {
                    value: Number(_vm.itemInfo.activityType),
                    disabled: _vm.activityTypeChecking,
                  },
                  on: { input: _vm.handleActivityTypeChange },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("新人专享")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("其他类型")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "背景图片：" } }, [
            _c("div", { staticClass: "upload-row" }, [
              _vm.userType === 1
                ? _c("div", { staticClass: "upload-row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "upLoadPicBox",
                        on: {
                          click: function ($event) {
                            return _vm.modalPicTap("1", "bgImg")
                          },
                        },
                      },
                      [
                        _vm.itemInfo.bgImg
                          ? _c("div", { staticClass: "pictrue" }, [
                              _c("img", { attrs: { src: _vm.itemInfo.bgImg } }),
                            ])
                          : _c("div", { staticClass: "upLoad" }, [
                              _c("i", {
                                staticClass: "el-icon-camera cameraIconfont",
                              }),
                            ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.itemInfo.bgImg
                      ? _c("i", {
                          staticClass: "el-icon-delete delete-icon",
                          on: {
                            click: function ($event) {
                              return _vm.removeImg("bgImg")
                            },
                          },
                        })
                      : _vm._e(),
                  ])
                : _c(
                    "div",
                    { staticClass: "upload-row" },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader-small",
                          attrs: {
                            action: "",
                            "show-file-list": false,
                            "http-request": function (options) {
                              return _vm.handleLocalUpload(options, "bgImg")
                            },
                            "before-upload": function (file) {
                              return _vm.beforeUpload(file, 500)
                            },
                            accept: ".jpg,.jpeg,.png,image/jpeg,image/png",
                          },
                        },
                        [
                          _vm.itemInfo.bgImg
                            ? _c("img", {
                                staticClass: "avatar-small",
                                attrs: { src: _vm.itemInfo.bgImg },
                              })
                            : _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon-small",
                              }),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.itemInfo.bgImg
                        ? _c("i", {
                            staticClass: "el-icon-delete delete-icon",
                            on: {
                              click: function ($event) {
                                return _vm.removeImg("bgImg")
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
              _vm._v(" "),
              _c("div", { staticClass: "upload-tip" }, [
                _vm._v("支持上传jpg、png、jpeg格式，图片大小需小于等于500KB"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "背景图跳转链接：" } },
            [
              _c("JumpNative", {
                staticStyle: { width: "240px" },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.bgUrl,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "bgUrl", $$v)
                  },
                  expression: "itemInfo.bgUrl",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "商品：" } }, [
            _c(
              "div",
              { staticClass: "link-text", on: { click: _vm.settingGoods } },
              [_vm._v("内容设置")]
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "随机排序：" } },
            [
              _c("el-switch", {
                attrs: {
                  "active-value": 1,
                  "inactive-value": 0,
                  "active-text": "开启",
                  "inactive-text": "关闭",
                },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.roderSort,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "roderSort", $$v)
                  },
                  expression: "itemInfo.roderSort",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "交互样式：" } },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.handleInteractionChange },
                  model: {
                    value: _vm.itemInfo.interactionType,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo, "interactionType", $$v)
                    },
                    expression: "itemInfo.interactionType",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v("手动左右滑动"),
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v("上下自动滚动"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "商品展示样式：" } },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.goodsShowType,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo, "goodsShowType", $$v)
                    },
                    expression: "itemInfo.goodsShowType",
                  },
                },
                _vm._l(_vm.availableGoodsShowTypes, function (item) {
                  return _c(
                    "el-radio",
                    { key: item.value, attrs: { label: item.value } },
                    [_vm._v(_vm._s(item.label))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "商品跳转链接：" } }, [
            _c(
              "div",
              [
                _c("JumpNative", {
                  staticStyle: { width: "240px" },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.goodsUrl,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo, "goodsUrl", $$v)
                    },
                    expression: "itemInfo.goodsUrl",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "upload-tip tip-warning" }, [
                  _vm._v("注：未配置链接则默认跳转至商品详情页"),
                ]),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeSetting === 2,
              expression: "activeSetting === 2",
            },
          ],
          attrs: { model: _vm.itemInfo, "label-width": "160px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "商品卡片展示样式：" } },
            [
              _c(
                "el-checkbox-group",
                {
                  attrs: { max: 3 },
                  on: { change: _vm.handleCardDisplayTypesChange },
                  model: {
                    value: _vm.itemInfo.cardDisplayTypes,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo, "cardDisplayTypes", $$v)
                    },
                    expression: "itemInfo.cardDisplayTypes",
                  },
                },
                _vm._l(_vm.availableCardDisplayOptions, function (item) {
                  return _c(
                    "el-checkbox",
                    { key: item.value, attrs: { label: item.value } },
                    [_vm._v(_vm._s(item.label))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "背景图布局：" } }, [
            _c("div", { staticClass: "layout-grid" }, [
              _c(
                "div",
                { staticClass: "layout-item" },
                [
                  _c("span", { staticClass: "layout-label" }, [
                    _vm._v("左边距："),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "layout-input",
                    attrs: { type: "number", min: 0, max: 100 },
                    on: { change: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.bgLayout.ml,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo.bgLayout, "ml", $$v)
                      },
                      expression: "itemInfo.bgLayout.ml",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("px")]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "layout-item" },
                [
                  _c("span", { staticClass: "layout-label" }, [
                    _vm._v("右边距："),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "layout-input",
                    attrs: { type: "number", min: 0, max: 100 },
                    on: { change: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.bgLayout.mr,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo.bgLayout, "mr", $$v)
                      },
                      expression: "itemInfo.bgLayout.mr",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("px")]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "layout-item" },
                [
                  _c("span", { staticClass: "layout-label" }, [
                    _vm._v("上边距："),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "layout-input",
                    attrs: { type: "number", min: 0, max: 100 },
                    on: { change: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.bgLayout.mt,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo.bgLayout, "mt", $$v)
                      },
                      expression: "itemInfo.bgLayout.mt",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("px")]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "layout-item" },
                [
                  _c("span", { staticClass: "layout-label" }, [
                    _vm._v("下边距："),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "layout-input",
                    attrs: { type: "number", min: 0, max: 100 },
                    on: { change: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.bgLayout.mb,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo.bgLayout, "mb", $$v)
                      },
                      expression: "itemInfo.bgLayout.mb",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("px")]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "radius-row" },
              [
                _c("span", { staticClass: "radius-label" }, [_vm._v("圆角：")]),
                _vm._v(" "),
                Number(_vm.itemInfo.bgCornerType) !== 2
                  ? [
                      _c("el-input", {
                        staticClass: "layout-input",
                        attrs: { type: "number", min: 0, max: 100 },
                        on: {
                          input: function () {
                            return _vm.syncBatchRadius("bgLayout")
                          },
                          change: function () {
                            return _vm.syncBatchRadius("bgLayout")
                          },
                        },
                        model: {
                          value: _vm.itemInfo.bgLayout.tl,
                          callback: function ($$v) {
                            _vm.$set(_vm.itemInfo.bgLayout, "tl", $$v)
                          },
                          expression: "itemInfo.bgLayout.tl",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("px")]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content:
                        Number(_vm.itemInfo.bgCornerType) === 2
                          ? "切换为批量修改"
                          : "切换为单独修改",
                      placement: "top",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "corner-toggle-btn",
                        class:
                          Number(_vm.itemInfo.bgCornerType) === 2
                            ? "is-batch"
                            : "is-single",
                        on: {
                          click: function ($event) {
                            return _vm.toggleCornerType(
                              "bgCornerType",
                              "bgLayout"
                            )
                          },
                        },
                      },
                      [_c("i", { staticClass: "iconfont icon-biankuang" })]
                    ),
                  ]
                ),
              ],
              2
            ),
            _vm._v(" "),
            Number(_vm.itemInfo.bgCornerType) === 2
              ? _c(
                  "div",
                  {
                    staticClass: "layout-grid",
                    staticStyle: { "margin-top": "8px" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "layout-item" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "layout-label layout-label-icon",
                            attrs: { title: "左上角" },
                          },
                          [
                            _c("i", {
                              staticClass: "iconfont icon-radius-upleft",
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "layout-input",
                          attrs: { type: "number", min: 0, max: 100 },
                          on: { change: _vm.updateItem },
                          model: {
                            value: _vm.itemInfo.bgLayout.tl,
                            callback: function ($$v) {
                              _vm.$set(_vm.itemInfo.bgLayout, "tl", $$v)
                            },
                            expression: "itemInfo.bgLayout.tl",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("px")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "layout-item" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "layout-label layout-label-icon",
                            attrs: { title: "右上角" },
                          },
                          [
                            _c("i", {
                              staticClass: "iconfont icon-radius-upright",
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "layout-input",
                          attrs: { type: "number", min: 0, max: 100 },
                          on: { change: _vm.updateItem },
                          model: {
                            value: _vm.itemInfo.bgLayout.tr,
                            callback: function ($$v) {
                              _vm.$set(_vm.itemInfo.bgLayout, "tr", $$v)
                            },
                            expression: "itemInfo.bgLayout.tr",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("px")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "layout-item" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "layout-label layout-label-icon",
                            attrs: { title: "左下角" },
                          },
                          [
                            _c("i", {
                              staticClass: "iconfont icon-radius-bottomleft",
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "layout-input",
                          attrs: { type: "number", min: 0, max: 100 },
                          on: { change: _vm.updateItem },
                          model: {
                            value: _vm.itemInfo.bgLayout.bl,
                            callback: function ($$v) {
                              _vm.$set(_vm.itemInfo.bgLayout, "bl", $$v)
                            },
                            expression: "itemInfo.bgLayout.bl",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("px")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "layout-item" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "layout-label layout-label-icon",
                            attrs: { title: "右下角" },
                          },
                          [
                            _c("i", {
                              staticClass: "iconfont icon-radius-bottomright",
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "layout-input",
                          attrs: { type: "number", min: 0, max: 100 },
                          on: { change: _vm.updateItem },
                          model: {
                            value: _vm.itemInfo.bgLayout.br,
                            callback: function ($$v) {
                              _vm.$set(_vm.itemInfo.bgLayout, "br", $$v)
                            },
                            expression: "itemInfo.bgLayout.br",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("px")]),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "商品在图片区域布局：" } }, [
            _c("div", { staticClass: "layout-grid" }, [
              _c(
                "div",
                { staticClass: "layout-item" },
                [
                  _c("span", { staticClass: "layout-label" }, [
                    _vm._v("左边距："),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "layout-input",
                    attrs: { type: "number", min: 0, max: 100 },
                    on: { change: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.goodsLayout.ml,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo.goodsLayout, "ml", $$v)
                      },
                      expression: "itemInfo.goodsLayout.ml",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("px")]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "layout-item" },
                [
                  _c("span", { staticClass: "layout-label" }, [
                    _vm._v("右边距："),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "layout-input",
                    attrs: { type: "number", min: 0, max: 100 },
                    on: { change: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.goodsLayout.mr,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo.goodsLayout, "mr", $$v)
                      },
                      expression: "itemInfo.goodsLayout.mr",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("px")]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "layout-item" },
                [
                  _c("span", { staticClass: "layout-label" }, [
                    _vm._v("上边距："),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "layout-input",
                    attrs: {
                      type: "number",
                      min: 0,
                      max: 100,
                      disabled: Number(_vm.itemInfo.goodsLayout.mb) !== 0,
                    },
                    on: {
                      change: function () {
                        return _vm.handleVerticalMarginChange(
                          "goodsLayout",
                          "mt"
                        )
                      },
                    },
                    model: {
                      value: _vm.itemInfo.goodsLayout.mt,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo.goodsLayout, "mt", $$v)
                      },
                      expression: "itemInfo.goodsLayout.mt",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("px")]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "layout-item" },
                [
                  _c("span", { staticClass: "layout-label" }, [
                    _vm._v("下边距："),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "layout-input",
                    attrs: {
                      type: "number",
                      min: 0,
                      max: 100,
                      disabled: Number(_vm.itemInfo.goodsLayout.mt) !== 0,
                    },
                    on: {
                      change: function () {
                        return _vm.handleVerticalMarginChange(
                          "goodsLayout",
                          "mb"
                        )
                      },
                    },
                    model: {
                      value: _vm.itemInfo.goodsLayout.mb,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo.goodsLayout, "mb", $$v)
                      },
                      expression: "itemInfo.goodsLayout.mb",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("px")]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "radius-row" },
              [
                _c("span", { staticClass: "radius-label" }, [_vm._v("圆角：")]),
                _vm._v(" "),
                Number(_vm.itemInfo.goodsCornerType) !== 2
                  ? [
                      _c("el-input", {
                        staticClass: "layout-input",
                        attrs: { type: "number", min: 0, max: 100 },
                        on: {
                          input: function () {
                            return _vm.syncBatchRadius("goodsLayout")
                          },
                          change: function () {
                            return _vm.syncBatchRadius("goodsLayout")
                          },
                        },
                        model: {
                          value: _vm.itemInfo.goodsLayout.tl,
                          callback: function ($$v) {
                            _vm.$set(_vm.itemInfo.goodsLayout, "tl", $$v)
                          },
                          expression: "itemInfo.goodsLayout.tl",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("px")]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content:
                        Number(_vm.itemInfo.goodsCornerType) === 2
                          ? "切换为批量修改"
                          : "切换为单独修改",
                      placement: "top",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "corner-toggle-btn",
                        class:
                          Number(_vm.itemInfo.goodsCornerType) === 2
                            ? "is-batch"
                            : "is-single",
                        on: {
                          click: function ($event) {
                            return _vm.toggleCornerType(
                              "goodsCornerType",
                              "goodsLayout"
                            )
                          },
                        },
                      },
                      [_c("i", { staticClass: "iconfont icon-biankuang" })]
                    ),
                  ]
                ),
              ],
              2
            ),
            _vm._v(" "),
            Number(_vm.itemInfo.goodsCornerType) === 2
              ? _c(
                  "div",
                  {
                    staticClass: "layout-grid",
                    staticStyle: { "margin-top": "8px" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "layout-item" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "layout-label layout-label-icon",
                            attrs: { title: "左上角" },
                          },
                          [
                            _c("i", {
                              staticClass: "iconfont icon-radius-upleft",
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "layout-input",
                          attrs: { type: "number", min: 0, max: 100 },
                          on: { change: _vm.updateItem },
                          model: {
                            value: _vm.itemInfo.goodsLayout.tl,
                            callback: function ($$v) {
                              _vm.$set(_vm.itemInfo.goodsLayout, "tl", $$v)
                            },
                            expression: "itemInfo.goodsLayout.tl",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("px")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "layout-item" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "layout-label layout-label-icon",
                            attrs: { title: "右上角" },
                          },
                          [
                            _c("i", {
                              staticClass: "iconfont icon-radius-upright",
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "layout-input",
                          attrs: { type: "number", min: 0, max: 100 },
                          on: { change: _vm.updateItem },
                          model: {
                            value: _vm.itemInfo.goodsLayout.tr,
                            callback: function ($$v) {
                              _vm.$set(_vm.itemInfo.goodsLayout, "tr", $$v)
                            },
                            expression: "itemInfo.goodsLayout.tr",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("px")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "layout-item" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "layout-label layout-label-icon",
                            attrs: { title: "左下角" },
                          },
                          [
                            _c("i", {
                              staticClass: "iconfont icon-radius-bottomleft",
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "layout-input",
                          attrs: { type: "number", min: 0, max: 100 },
                          on: { change: _vm.updateItem },
                          model: {
                            value: _vm.itemInfo.goodsLayout.bl,
                            callback: function ($$v) {
                              _vm.$set(_vm.itemInfo.goodsLayout, "bl", $$v)
                            },
                            expression: "itemInfo.goodsLayout.bl",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("px")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "layout-item" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "layout-label layout-label-icon",
                            attrs: { title: "右下角" },
                          },
                          [
                            _c("i", {
                              staticClass: "iconfont icon-radius-bottomright",
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "layout-input",
                          attrs: { type: "number", min: 0, max: 100 },
                          on: { change: _vm.updateItem },
                          model: {
                            value: _vm.itemInfo.goodsLayout.br,
                            callback: function ($$v) {
                              _vm.$set(_vm.itemInfo.goodsLayout, "br", $$v)
                            },
                            expression: "itemInfo.goodsLayout.br",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("px")]),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("EditMarket", {
        ref: "EditMarketRef",
        attrs: { pageType: _vm.pageType, onlySelfSku: true },
        on: { saveEdit: _vm.saveGoods },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }